import React from "react";
import { BrowserRouter, HashRouter, Switch } from "react-router-dom";
import { Footer_ScreenProvider } from "../screens/footer/footer-context";
import { ReportsRefferalCustomerDetailing_Screen } from "../screens/reportsrefferalcustomerdetailing/reportsrefferalcustomerdetailing";
import { Test_Screen } from "../screens/test/test";
import { EndOfSProductFourthWeb_Screen } from "../screens/endofsproductfourthweb/endofsproductfourthweb";
import { Yusufbosekran_Screen } from "../screens/yusufbosekran/yusufbosekran";
import { LeftMenucopy_Screen } from "../screens/leftmenucopy/leftmenucopy";
import { ReportsAdminSales_Screen } from "../screens/reportsadminsales/reportsadminsales";
import { EndOfProductCollectionWeb_Screen } from "../screens/endofproductcollectionweb/endofproductcollectionweb";
import { VerificationCode_Screen } from "../screens/verificationcode/verificationcode";
import { HomePageAdmin_Screen } from "../screens/homepageadmin/homepageadmin";
import { AdminNotifManagement_Screen } from "../screens/adminnotifmanagement/adminnotifmanagement";
import { CustomerNotifcationList_Screen } from "../screens/customernotifcationlist/customernotifcationlist";
import { Authentication_Sign_Up_Screen } from "../screens/authentication_sign_up/authentication_sign_up";
import { Signin_Screen } from "../screens/signin/signin";
import { ProductListDesignWeb_Screen } from "../screens/productlistdesignweb/productlistdesignweb";
import { ReportsSalesCustomer_Screen } from "../screens/reportssalescustomer/reportssalescustomer";
import { Translate_Screen } from "../screens/translate/translate";
import { ReportsRefferalCustomer_Screen } from "../screens/reportsrefferalcustomer/reportsrefferalcustomer";
import { ReportsCustomer_Screen } from "../screens/reportscustomer/reportscustomer";
import { ProductListCollectionWebScreen_Screen } from "../screens/productlistcollectionwebscreen/productlistcollectionwebscreen";
import { FavoritesListDesignWeb_Screen } from "../screens/favoriteslistdesignweb/favoriteslistdesignweb";
import { EndOfProductDesignWeb_Screen } from "../screens/endofproductdesignweb/endofproductdesignweb";
import { ReportsAdminRefferalPending_Screen } from "../screens/reportsadminrefferalpending/reportsadminrefferalpending";
import { HomePageCustomer_Screen } from "../screens/homepagecustomer/homepagecustomer";
import { ReportsCustomerSalesDetail_Screen } from "../screens/reportscustomersalesdetail/reportscustomersalesdetail";
import { HizliStokWeb_Screen } from "../screens/hizlistokweb/hizlistokweb";
import { SideMenu_Screen } from "../screens/sidemenu/sidemenu";
import { Authentication_Forgot_Password_Screen } from "../screens/authentication_forgot_password/authentication_forgot_password";
import { ProductBasketWeb_Screen } from "../screens/productbasketweb/productbasketweb";
import { SocialMedia_Screen } from "../screens/socialmedia/socialmedia";
import { Authentication_Forgot_PasswordVerificationCode_Screen } from "../screens/authentication_forgot_passwordverificationcode/authentication_forgot_passwordverificationcode";
import { Footer_Screen } from "../screens/footer/footer";
import { ProductFourthWeb_Screen } from "../screens/productfourthweb/productfourthweb";
import { ProductListCollectionSelectedWebScreen_Screen } from "../screens/productlistcollectionselectedwebscreen/productlistcollectionselectedwebscreen";
import { Mertbosekran_Screen } from "../screens/mertbosekran/mertbosekran";
import { LeftMenu_Screen } from "../screens/leftmenu/leftmenu";
import { ReportsRefferalCustomerHeader_Screen } from "../screens/reportsrefferalcustomerheader/reportsrefferalcustomerheader";
import { Authentication_Verification_Code_Screen } from "../screens/authentication_verification_code/authentication_verification_code";
import { ReportsFirstPage_Screen } from "../screens/reportsfirstpage/reportsfirstpage";
import { ReportsAdminRefferalPendingHeader_Screen } from "../screens/reportsadminrefferalpendingheader/reportsadminrefferalpendingheader";
import { Profile_Screen } from "../screens/profile/profile";
import { Authentication_Reset_Password_Screen } from "../screens/authentication_reset_password/authentication_reset_password";
import { ReportsAdminRefferalPendingDetail_Screen } from "../screens/reportsadminrefferalpendingdetail/reportsadminrefferalpendingdetail";
import { ReportsAdminRefferal_Screen } from "../screens/reportsadminrefferal/reportsadminrefferal";
import { AuthRotate_Screen } from "../screens/authrotate/authrotate";



import LocalStorageService from "../auth/local-storage-service";
import { Redirect } from "../auth/redirect";
import { IAppMode, IAuthType } from "../bootstrapper";
import { NoMatch404 } from "../components/common/no-match-404";
import { Dashboard, ForgotPassword, Login, ResetPassword } from "../components/default_screens/index";
import { KuikaInfo } from "../components/default_screens/kuika-info";
import { MfeLogin } from "../components/mfe/mfe-login";
import { MsalLogin } from "../components/msal/msal-login";
import { MsalRedirect } from "../components/msal/msal-redirect";
import { NotificationRedirect } from "../components/notification/notification-redirect";
import { ScanCompareTest } from "../screens/scan-compare-test";
import { WFMailInteraction } from "../screens/wf-mail-interaction";
import confJson from "../shared/json/conf.json";
import { KMainFunctions } from "../shared/utilty/main-functions";
import { MasterScreenWrapper } from "./master-screen-wrapper";
import { PrivateRoute } from "./private-route";
import { Route } from "./route";

class Footer_Screen_Wrapper extends MasterScreenWrapper {
  protected get anonymousPaths(): string[] { return []; }
  protected get MasterComponent(): React.ComponentType<any> { return Footer_Screen; }
  protected get MasterProvider(): React.ComponentType<any> { return Footer_ScreenProvider; }
  protected renderSwitchWrapper(): React.ReactNode {
    return (
      <Switch>
        <PrivateRoute exact path="/reportsrefferalcustomerdetailing" component={ReportsRefferalCustomerDetailing_Screen} />
        <PrivateRoute exact path="/endofsproductfourthweb" component={EndOfSProductFourthWeb_Screen} />
        <PrivateRoute exact path="/reportsadminsales" component={ReportsAdminSales_Screen} />
        <PrivateRoute exact path="/endofproductcollectionweb" component={EndOfProductCollectionWeb_Screen} />
        <PrivateRoute exact path="/homepageadmin" component={HomePageAdmin_Screen} />
        <PrivateRoute exact path="/adminnotifmanagement" component={AdminNotifManagement_Screen} />
        <PrivateRoute exact path="/customernotifcationlist" component={CustomerNotifcationList_Screen} />
        <PrivateRoute exact path="/productlistdesignweb" component={ProductListDesignWeb_Screen} />
        <PrivateRoute exact path="/reportssalescustomer" component={ReportsSalesCustomer_Screen} />
        <PrivateRoute exact path="/reportsrefferalcustomer" component={ReportsRefferalCustomer_Screen} />
        <PrivateRoute exact path="/reportscustomer" component={ReportsCustomer_Screen} />
        <PrivateRoute exact path="/productlistcollectionwebscreen" component={ProductListCollectionWebScreen_Screen} />
        <PrivateRoute exact path="/favoriteslistdesignweb" component={FavoritesListDesignWeb_Screen} />
        <PrivateRoute exact path="/endofproductdesignweb" component={EndOfProductDesignWeb_Screen} />
        <PrivateRoute exact path="/reportsadminrefferalpending" component={ReportsAdminRefferalPending_Screen} />
        <PrivateRoute exact path="/homepagecustomer" component={HomePageCustomer_Screen} />
        <PrivateRoute exact path="/hizlistokweb" component={HizliStokWeb_Screen} />
        <PrivateRoute exact path="/productbasketweb" component={ProductBasketWeb_Screen} />
        <PrivateRoute exact path="/socialmedia" component={SocialMedia_Screen} />
        <PrivateRoute exact path="/productfourthweb" component={ProductFourthWeb_Screen} />
        <PrivateRoute exact path="/productlistcollectionselectedwebscreen" component={ProductListCollectionSelectedWebScreen_Screen} />
        <PrivateRoute exact path="/reportsrefferalcustomerheader" component={ReportsRefferalCustomerHeader_Screen} />
        <PrivateRoute exact path="/reportsfirstpage" component={ReportsFirstPage_Screen} />
        <PrivateRoute exact path="/reportsadminrefferalpendingheader" component={ReportsAdminRefferalPendingHeader_Screen} />
        <PrivateRoute exact path="/profile" component={Profile_Screen} />
        <PrivateRoute exact path="/reportsadminrefferalpendingdetail" component={ReportsAdminRefferalPendingDetail_Screen} />
        <PrivateRoute exact path="/reportsadminrefferal" component={ReportsAdminRefferal_Screen} />
      </Switch>
    );
  }
}



export interface IRouterState {}

export type IRouterType = "HashRouter" | "BrowserRouter";

export interface IRouterProps {
  authType: IAuthType;
  routerType?: IRouterType;
  external_access_token?: string;
  external_refresh_token?: string;
  external_user?: string;
  startingScreen?: string;
  appMode?: IAppMode;
  // Allow only screenInput_* props with specific typing
  [key: `screenInput_${string}`]: unknown;
}

declare let window: any;
export class Router extends React.Component<IRouterProps, IRouterState> {
  timerId: any = null;

  private hasNavigatedToStartingScreen: boolean = false;

  componentDidMount = () => {
    // SET LANGUAGE TO HTML BODY
    const lang = LocalStorageService.getUserLanguage();
    if (lang) {
      const fixedLangAttributeValue = lang.replace("_", "-");
      document.body.setAttribute("lang", fixedLangAttributeValue);
    }
    // Handle starting screen navigation for web component apps (only once)
    if (this.props.appMode === "WebComponent" && this.props.startingScreen && !this.hasNavigatedToStartingScreen) {
      this.hasNavigatedToStartingScreen = true;
      this.navigateToStartingScreen();
    }

    window.onfocus = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = true;
    };

    window.onblur = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = false;
    };

    if (!window.styler_speed) {
      window.styler_speed = 20;
    } else if (window.styler_speed < 500) {
      window.styler_speed += 100;
    }

    if (window?.kuika?.activeKuikaComponent !== undefined) {
      return;
    }
    const runTimeout = () => {
      this.timerId = setTimeout(() => {
        const allFormItems: NodeListOf<HTMLElement> = document.querySelectorAll(".kFormItem");
        if (allFormItems) {
          allFormItems.forEach((formItem) => {
            if (formItem.getAttribute("data-display-affected") === "true") {
              return;
            }
            const antFormItemControlInputContent: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input .ant-form-item-control-input-content"
            );
            const antFormItemControlInput: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input"
            );
            const antFormItemControl: HTMLElement = formItem.querySelector(".ant-form-item-control");

            if (
              antFormItemControlInputContent &&
              antFormItemControlInputContent.children &&
              antFormItemControlInputContent.children.length > 0
            ) {
              const formChild: HTMLElement = antFormItemControlInputContent.children[0] as HTMLElement;
              let calculatedDisplay: string = formChild.style.display;
              if (
                calculatedDisplay &&
                antFormItemControl &&
                antFormItemControlInput &&
                antFormItemControlInputContent
              ) {
                if (calculatedDisplay === "inline-flex" || calculatedDisplay === "inline-block") {
                  calculatedDisplay = "";
                  formItem.style.width = formChild.style.width ?? "auto";
                  formItem.style.display = "inline-block";
                  formItem.setAttribute("data-display-affected", "true");
                }
              }
            }
          });
        }
        this.componentDidMount();
      }, window.styler_speed);
    };

    runTimeout();

    setTimeout(() => {
      clearTimeout(this.timerId);
    }, 10000);
  };

  private getScreenInputPropKeys = (): string[] => {
    return Object.keys(this.props || {}).filter((k) => k && k.startsWith("screenInput_"));
  };

  private buildScreenInputsFromProps = (): Record<string, unknown> => {
    const screenInputs: Record<string, unknown> = {};
    this.getScreenInputPropKeys().forEach((key) => {
      const inputName = key.substring("screenInput_".length);
      screenInputs[inputName] = this.props[key];
    });
    return screenInputs;
  };

  private navigateToStartingScreen = () => {
    try {
      const screenName = this.props.startingScreen as string;
      const baseHash = screenName.startsWith("#") ? screenName : `#${screenName}`;
      const inputs = this.buildScreenInputsFromProps();
      const params = new URLSearchParams();

      Object.keys(inputs).forEach((k) => {
        const v = inputs[k];
        if (v !== undefined && v !== null) {
          params.append(k, typeof v === "string" ? v : JSON.stringify(v));
        }
      });

      const qs = params.toString();
      const hash = `${baseHash}${qs ? `?${qs}` : ""}`;

      if (window.location.hash !== hash) {
        window.location.hash = hash;
      }
    } catch (e) {
      console.error("Error navigating to starting screen:", e);
    }
  };

  render() {
    const KuikaRouter = this.KuikaRouter();
    return (
      <>
        <KuikaRouter>
          <Switch key="Switch">
                        <PrivateRoute exact path="/" component={AuthRotate_Screen} />
                        <Route path={["/reportsrefferalcustomerdetailing", "/endofsproductfourthweb", "/reportsadminsales", "/endofproductcollectionweb", "/homepageadmin", "/adminnotifmanagement", "/customernotifcationlist", "/productlistdesignweb", "/reportssalescustomer", "/reportsrefferalcustomer", "/reportscustomer", "/productlistcollectionwebscreen", "/favoriteslistdesignweb", "/endofproductdesignweb", "/reportsadminrefferalpending", "/homepagecustomer", "/hizlistokweb", "/productbasketweb", "/socialmedia", "/productfourthweb", "/productlistcollectionselectedwebscreen", "/reportsrefferalcustomerheader", "/reportsfirstpage", "/reportsadminrefferalpendingheader", "/profile", "/reportsadminrefferalpendingdetail", "/reportsadminrefferal"]} component={Footer_Screen_Wrapper} />
            <PrivateRoute exact path="/test" component={Test_Screen} />
            <PrivateRoute exact path="/yusufbosekran" component={Yusufbosekran_Screen} />
            <PrivateRoute exact path="/leftmenucopy" component={LeftMenucopy_Screen} />
            <Route exact path="/verificationcode" component={VerificationCode_Screen} />
            <Route exact path="/authentication_sign_up" component={Authentication_Sign_Up_Screen} />
            <Route exact path="/signin" component={this.LoginComponent()} />
            <PrivateRoute exact path="/translate" component={Translate_Screen} />
            <PrivateRoute exact path="/reportscustomersalesdetail" component={ReportsCustomerSalesDetail_Screen} />
            <PrivateRoute exact path="/sidemenu" component={SideMenu_Screen} />
            <Route exact path="/authentication_forgot_password" component={Authentication_Forgot_Password_Screen} />
            <Route exact path="/authentication_forgot_passwordverificationcode" component={Authentication_Forgot_PasswordVerificationCode_Screen} />
            <PrivateRoute exact path="/mertbosekran" component={Mertbosekran_Screen} />
            <PrivateRoute exact path="/leftmenu" component={LeftMenu_Screen} />
            <Route exact path="/authentication_verification_code" component={Authentication_Verification_Code_Screen} />
            <Route exact path="/authentication_reset_password" component={Authentication_Reset_Password_Screen} />
            <PrivateRoute exact path="/authrotate" component={AuthRotate_Screen} />

            <Route path="/redirect" component={Redirect} />
            <Route path={"/login"} component={this.LoginComponent()} />
            
            
            <Route exact path="/forgotpassword" component={ForgotPassword} />
            <Route exact path="/resetpassword" component={ResetPassword} />
            <PrivateRoute exact path="/dashboard" component={Dashboard} />
            <Route exact path="/kuikainfo" component={KuikaInfo} />
            <Route exact path="/msalredirect" component={MsalRedirect} />
            <Route exact path="/wfmailinteraction" component={WFMailInteraction} />
            <PrivateRoute exact path="/scancomparetest" component={ScanCompareTest} />
            <Route exact path="/notificationredirect" component={NotificationRedirect} />
            <Route exact path="/logout" component={Redirect} />
            <Route path="*" component={NoMatch404} />
          </Switch>
        </KuikaRouter>
      </>
    );
  }

  KuikaRouter = () => {
    // Web component case
    let isWebComponentApp: any;
    isWebComponentApp = this.props.appMode === "WebComponent";
    if (
      confJson?.domainName !== undefined &&
      confJson?.applicationName !== undefined &&
      confJson?.applicationName !== "" &&
      window.kuika !== undefined &&
      window.kuika?.apps !== undefined &&
      window.kuika?.apps.length !== undefined &&
      window.kuika?.apps.length > 0
    ) {
      window.kuika?.apps.forEach((app: any) => {
        if (app.appName === confJson.applicationName && app.workspace === confJson.domainName) {
          isWebComponentApp = true;
        }
      });
    }
    if (window.kuika === undefined) {
      window.kuika = {};
    }
    window.kuika.isWebComponentApp = isWebComponentApp;

    if (isWebComponentApp === true || this.props.routerType === "HashRouter") {
      return (props: any) => {
        return <HashRouter key="HashRouter">{props.children}</HashRouter>;
      };
    }
    return (props: any) => {
      if (KMainFunctions.virtualDirectoryURL === "auto" || window?.location?.protocol === "file:") {
        return <BrowserRouter key="BrowserRouter">{props.children}</BrowserRouter>;
      }
      return (
        <BrowserRouter basename={KMainFunctions.virtualDirectoryURL} key="BrowserRouter">
          {props.children}
        </BrowserRouter>
      );
    };
  };

  LoginComponent = () => {
    if (this.props.authType === "MSAL") {
      return MsalLogin;
    }

    const { external_access_token } = this.props;
    const { external_refresh_token } = this.props;
    const { external_user } = this.props;
    // The host injects external_access_token as a short-lived MFE handoff JWT.
    // No refresh_token is involved — the microapp's own backend mints its
    // session cookies once the token is redeemed.
    if (external_access_token !== null && external_access_token !== undefined && external_access_token !== "") {
      return (props: any) => {
        return (
          <MfeLogin
            external_user={external_user}
            external_access_token={external_access_token}
            external_refresh_token={external_refresh_token}
          ></MfeLogin>
        );
      };
    }

    if (this.props.authType === "Kuika") {
      return Signin_Screen;
    }
    return <></>;
  };
}
